/**
 * 初回表示オンボーディング（3ステップ）
 * 空状態ヒーローと同じ手順文言。横1行のコンパクト帯にして作業領域を奪わない。
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button } from 'react-bootstrap';
import { safeLocalStorageSetJson } from './keisukeDashboardLocalStorage';
import styles from './KeisukeDashboardOnboarding.module.scss';

const ONBOARDING_KEY = 'keisuke-workspace-onboarding-dismissed';

function isDismissed(): boolean {
  try {
    return localStorage.getItem(ONBOARDING_KEY) === '1';
  } catch {
    return false;
  }
}

export function reopenKeisukeOnboarding(): void {
  try {
    localStorage.removeItem(ONBOARDING_KEY);
  } catch {
    // ignore
  }
}

export default function KeisukeDashboardOnboarding() {
  const { t } = useTranslation();
  /** 空ヒーローが初回手順を担う。帯は「使い方」からの明示表示のみ（結果後のレイアウト押し下げを避ける） */
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const show = () => {
      reopenKeisukeOnboarding();
      setVisible(true);
    };
    window.addEventListener('keisuke-show-onboarding', show);
    return () => window.removeEventListener('keisuke-show-onboarding', show);
  }, []);

  if (!visible) return null;

  const dismiss = () => {
    try {
      localStorage.setItem(ONBOARDING_KEY, '1');
    } catch {
      safeLocalStorageSetJson(ONBOARDING_KEY, '1');
    }
    setVisible(false);
  };

  return (
    <Alert variant="info" className={styles.banner}>
      <div className={styles.row}>
        <strong className={styles.title}>{t('keisuke.workspace.onboarding.title')}</strong>
        <ol className={styles.steps}>
          <li>{t('keisuke.workspace.onboarding.step1')}</li>
          <li>{t('keisuke.workspace.onboarding.step2')}</li>
          <li>{t('keisuke.workspace.onboarding.step3')}</li>
        </ol>
        <Button
          size="sm"
          variant="outline-primary"
          className={styles.dismiss}
          onClick={dismiss}
        >
          {t('keisuke.workspace.onboarding.dismiss')}
        </Button>
      </div>
    </Alert>
  );
}
